/**
 * Capitalize a string to make the first character uppercase.
 * @param {string} str - any string, example "abc"
 * @returns {string} - returns string with first capital letter, example "Abc"
 */
export const capitalize = (str: string) => {
  return str.charAt(0).toUpperCase() + str.slice(1);
};
